/* 
 *  Copyright © Ludvik Michalek, Bigfoot Interactive
 *  http://www.bigfoot.cz/
 *  
 *  Requires js-cookie
 */

function ProficiencyPopup(containerObject){
	/* THIS FIX */
	var _this = this;
	
	/* PRIVATE CONSTANTS */
	var SHOW_DELAY = 0;
	var EXPIRATION_DAYS = 365;

	
	/* PRIVATE VARIABLES */
	var overlay;
	var popupContent;
	var agreeButton;
	var cookieId = 'proficiency-required-popup';
	var visible = false;


	/* PUBLIC PROPERTIES */
	this.container = null;
	this.inited = false;
	
	
	/* PRIVATE FUNCTIONS */
	function _construct(){
		_this.container = containerObject;
		_this.init();
	}	
	
	
	function checkCookie(){
		var status = parseInt(Cookies.get(cookieId));
		if(status !== 1) {
			setTimeout(show, SHOW_DELAY);
		} else {
			_this.container.remove();
		}
	}
	
	
	function saveCookie(){
		Cookies.set(cookieId, 1, { expires: EXPIRATION_DAYS });
	}
	
	
	function show(){
		overlay.addClass('visible');
		_this.container.addClass('visible');
		bodyScrollLock.disableBodyScroll(popupContent[0]);
		visible = true;
	}
	
	
	function hide(){
		saveCookie();
		overlay.removeClass('visible');
		_this.container.removeClass('visible');
		bodyScrollLock.enableBodyScroll(popupContent[0]);
		visible = false;
	}

	
	function updateAgreeStatus(){
		var status1 = $('input[name="agree-1"]', _this.container).is(":checked");
		var status2 = $('input[name="agree-2"]', _this.container).is(":checked");
		
		// enable button
		if(status1 && status2) {
			agreeButton.removeClass('disabled');
		} else {
			agreeButton.addClass('disabled');
		}
	}


	/* PUBLIC FUNCTIONS */	
	this.init = function(){
		if(!_this.inited){	
			// object references
			overlay = $('#proficiency-popup-overlay');
			popupContent = $('.popup-content', _this.container);
			agreeButton = $('button.agree', _this.container);
			var checkbox = $('input[type="checkbox"]', _this.container);
			
			// init
			checkCookie();
	
			// handlers
			agreeButton.click(function(e){
				e.preventDefault();
				if(!$(this).hasClass('disabled')) {
					hide();
				}
			});		
			checkbox.change(function(e){
				e.preventDefault();
				updateAgreeStatus();
			});		
			$(document).keyup(function (e) {
				if (visible && e.key === "Escape") {
					hide();
				}
			});
			
			_this.inited = true;
		}
	};


	/* INIT CONSTRUCTOR */
	_construct();
}


/* PUBLIC CONSTANTS */
